export const ORGANIZATION_BOARDS = 'boards';
export const ORGANIZATION_DETAILS = 'details';
export const ORGANIZATION_TEAM = 'team';
export const USER_DETAILS = 'details';
export const USER_ORGANIZATIONS = 'organizations';
export const BOARD_DETAILS = 'details';

export const initialState = {
  boards: {
    // :boardID { details }
  },
  organizations: {
    // :organizationID { team, details, boards }
  },
  user: {
    details: false,
    organizations: false,
  },
};
